import { useQuery } from "@tanstack/react-query";
import { applicationService } from "@/services/applicationService";

// query keys
export const applicationQueryKeys = {
  all: ["applications"],
  list: () => [...applicationQueryKeys.all, "list"],
  details: (vacancyId) => ['applications', 'vacancy', vacancyId],
  byId: (applicationId) => ['application', applicationId],
};


// get applications by vacancy id
export const useApplicationsByVacancyId = (vacancyId, filters = null) => {
  const queryKey = filters?.queryKey || [...applicationQueryKeys.details(vacancyId)];
  return useQuery({
    queryKey,
    queryFn: () => applicationService.getApplicationsByVacancyId(vacancyId, filters),
    enabled: !!vacancyId,
    staleTime: 0, // Consider data stale immediately
    cacheTime: 0, // Don't cache the data
  });
};


export const useApplicationsByVacancyIdKanban = (vacancyId, filters = null) => {
  const queryKey = filters?.queryKey || [...applicationQueryKeys.details(vacancyId), filters];
  return useQuery({
    queryKey,
    queryFn: () => applicationService.getApplicationsByVacancyIdKanban(vacancyId, filters),
    enabled: !!vacancyId,
    staleTime: 1000 * 60, // Consider data stale immediately
    cacheTime: 1000 * 60 * 5, // Don't cache the data
  });
};

export const useApplicationsForPreScreen = (vacancyId, filters = null) => {
  return useQuery({
    queryKey: [...applicationQueryKeys.details(vacancyId), filters],
    queryFn: () => applicationService.getApplicationsForPreScreen(vacancyId, filters),
    enabled: !!vacancyId,
  });
};

export const useApplicationById = (applicationId) => {
  return useQuery({
    queryKey: applicationQueryKeys.byId(applicationId),
    queryFn: async () => {
      const response = await applicationService.getApplictionByID(applicationId);
      return response;
    },
    enabled: !!applicationId,
  });
};

// get applications stats by vacancy id
export const useApplicationsByVacancyIdStats = (vacancyId, filters = null) => {
  const queryKey = filters?.queryKey || [...applicationQueryKeys.details(vacancyId), 'stats'];
  return useQuery({
    queryKey,
    queryFn: () => applicationService.getApplicationsByVacancyIdStats(vacancyId, filters),
    enabled: !!vacancyId,
    staleTime: 0, // Consider data stale immediately
    cacheTime: 0, // Don't cache the data
  });
};





